/*
 * @Date: 2025-03-31 02:32:53
 * @LastEditors: lifangdi
 * @LastEditTime: 2025-07-03 01:27:23
 */
import React, { Suspense } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import styled, { createGlobalStyle } from "styled-components";
import DynamicTitle from "./components/DynamicTitle";
import CookieConsent from "./components/CookieConsent";
const DefinedRouters = React.lazy(() => import("./router"));

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    margin: 0;
    padding: 0;
    font-size: 0.18rem;
    color: #fff;
    font-family: 'neue-haas-grotesk-text','neue-haas-grotesk-display', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #181818;
  }
`;
const LoadingContainer = styled.div`
  position: fixed;
  top: 0.3rem;
  left: 0.3rem;
  font-size: 0.18rem;
  line-height: 0.22rem;
  font-weight: 500;
  @media (max-width: 768px) {
    top: 0.2rem;
    left: 0.2rem;
    font-size: 0.24rem;
    line-height: 0.24rem;
    font-family: "neue-haas-grotesk-display", sans-serif;
    font-weight: 400;
  }
`;
function App() {
  return (
    <Router>
      <GlobalStyle />
      <DynamicTitle />
      <Suspense fallback={<LoadingContainer>Loading...</LoadingContainer>}>
        <DefinedRouters />
      </Suspense>
      <CookieConsent />
    </Router>
  );
}

export default App;
